import confirmMarkAsPhishing from './helpers/confirmMarkAsPhishing';
import filterRowKeysByExistence from './helpers/filterRowKeysByExistence';
import getInstrumentationContextsFromTableView from 'owa-mail-list-store/lib/utils/getInstrumentationContextsFromTableView';
import getItemIdsFromConversations from 'owa-mail-list-store/lib/utils/getItemIdsFromConversations';
import markItemsAsPhishingBasedOnItemIds from './helpers/markItemsAsPhishingBasedOnItemIds';
import { actionNames } from 'owa-mail-store-actions';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { userMailInteractionAction } from 'owa-mail-actions';
/**
 * Mark the conversation as phishing with the confirm dialog
 * @param conversationRowKeys the specified conversation ids to be marked as phishing
 * @param tableView that contains the rows
 * @param actionSource the action source where this action is triggered from
 * @return a function which shows the confirmation dialog
 */
export default function markConversationsAsPhishingFromTable(conversationRowKeys, tableView, actionSource) {
    // Calls a helper method to trigger the confirm dialog before processing mark as phishing
    confirmMarkAsPhishing(function () {
        markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource);
    });
}
/**
 * mark conversations as phishing action
 * @param conversationRowKeys rowKeys for the specified conversations
 * @param tableView the table view id
 * @param actionSource the action source where this action is triggered from
 */
function markConversationsAsPhishingInternal(conversationRowKeys, tableView, actionSource) {
    // Since rows may have been deleted from the table while the confirm dialog was open,
    // we need to validate the rows exist before proceeding
    var filteredRowKeys = filterRowKeysByExistence(conversationRowKeys, tableView);
    if (filteredRowKeys.length == 0) {
        // Nothing to remove
        return;
    }
    var instrumentationContexts = getInstrumentationContextsFromTableView(conversationRowKeys, tableView);
    // Get the de-duped conversation ids
    var conversationIdStrings = getRowIdsFromRowKeys(filteredRowKeys, tableView.id);
    // Get all itemIds inside the conversations
    var itemIdsToUpdate = getItemIdsFromConversations(filteredRowKeys, tableView.id);
    markItemsAsPhishingBasedOnItemIds(itemIdsToUpdate, actionSource, function () {
        // raise stitch to delete conversation from reading pane and list view
        raiseAction(actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
    });
    userMailInteractionAction('MarkAsPhishing', instrumentationContexts);
}
//# sourceMappingURL=markConversationsAsPhishingFromTable.js.map